import { useMutation, useQueryClient } from '@tanstack/react-query'

import { messageApi } from '../api/messageApi'
import { getConversationsPreviewOptions } from './useConversationsPreviewQuery'
import { getConversationOptions } from './useSingleConversationQuery'

export const useUnblockConversationMutation = (conversationId: number) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: () => messageApi.unblockConversation(conversationId),
    onSuccess: () => {
      queryClient.setQueryData(
        getConversationOptions(conversationId).queryKey,
        (data) =>
          data && {
            ...data,
            isBlocked: false,
          },
      )
      queryClient.setQueryData(
        getConversationsPreviewOptions().queryKey,
        (data) =>
          data && {
            ...data,
            pages: data.pages.map((page) =>
              page.map((conversation) =>
                conversation.id === conversationId ? { ...conversation, isBlocked: false } : conversation,
              ),
            ),
          },
      )
    },
  })
}
